import React from 'react';
import { PARAMS } from "../../../../config";
const redStyle = { background: 'red' };

const Row = (row) => {
    const td = PARAMS.map(([ param ]) => {
        let value = row[param];
        const style = (param == 'cD' || param == 'rD') && value < 70 ? redStyle : {};

        if(param == 'cD' || param == 'rD') value = `${value}%`;

        return <td style={style} key={param}>{value}</td>;
    });

    return <tr>{td}</tr>;
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderQuality/components/Table/components/Row/index.js